import axios, { API_BASE, handler } from './http-service';
import { TokenVerify } from '../components/interfaces';

export const verify = async (): Promise<TokenVerify> => {
  const url = API_BASE + '/verify-token';
  const response = await handler(() => axios.get(url));
  return response;
}

const tokenService = { verify };

export default tokenService;
